// Header search
const HeaderSearch = () => {
    const header = document.querySelector('.site-header');
    if (!header) return;
    
    const searchIcon = header.querySelector('.open-search');
    if (!searchIcon) return;

    searchIcon.addEventListener('mouseenter', () => {
        header.classList.add('light-header');
    });

    searchIcon.addEventListener('mouseleave', () => {
        setTimeout(() => {
            header.classList.remove('light-header');
        }, 500);
    });

    
    // Get search query
    const searchOverlay = document.querySelector('.search-overlay');
    if (!searchOverlay) return;
    
    // Open search
    searchIcon.addEventListener('click', (e) => {
        e.preventDefault();
        toggleSearchOverlay();

        const mobileIcon = document.querySelector('.burger-menu');

        // Toggle mobileIcon visibility
        if (mobileIcon) {
            mobileIcon.style.visibility = mobileIcon.style.visibility === 'hidden' ? 'visible' : 'hidden';
        }
        

    });

    const toggleSearchOverlay = () => {
        const isOpen = searchOverlay.classList.toggle('open');
        header.classList.toggle('search-open', isOpen);
        searchIcon.textContent = isOpen ? 'close' : 'search';
        searchOverlay.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
        document.body.style.overflow = isOpen ? 'hidden' : 'visible';
        document.body.style.height = isOpen ? '100vh' : 'auto';

        if (isOpen) {
            const headerHeight = header.offsetHeight;
            searchOverlay.style.top = `${headerHeight}px`;
            searchOverlay.querySelector('.search-form input.search-field').focus();
        }
    };

    // Get search query and update button URL
    const searchField = searchOverlay.querySelector('.search-form input.search-field');
    if (!searchField) return;

    searchField.addEventListener('input', (e) => {
        const searchQuery = e.target.value;

        // Set a debounce to avoid too many requests
        setTimeout(() => {
            console.log(searchQuery);

            // Watch for changes in .ajax-results
            const observer = new MutationObserver((mutationsList) => {
                for (const mutation of mutationsList) {
                    if (mutation.type === 'childList') {
                        console.log('A child node has been added or removed.');

                        // If the search results are loaded, update the button url
                        const searchButton = searchOverlay.querySelector('.ajax-results .wp-block-button__link');
                        if (searchButton) {
                            // Remove existing query string (if any)
                            const url = new URL(searchButton.href);
                            url.searchParams.set('s', searchQuery);

                            // Update the button's href with the new query string
                            searchButton.href = url.toString();
                        }
                    }
                }
            });

            observer.observe(searchOverlay.querySelector('.ajax-results'), { childList: true });
        }, 500);
    });
}

export default HeaderSearch;